<template>
  <v-app id="app">
    <router-view />
  </v-app>
</template>

<script>
import store from "@/store";

export default {
  watch: {
    $route: (route) => {
      store.commit("setCurrentNav", route.name.toLowerCase());
    }
  },

  created() {
    store.dispatch("startSessionTimer");
  }
};
</script>

<style lang="scss">
@import "~vuetify/dist/vuetify.min.css";
</style>
